<template>
  <div class="export">
    <div class="dashboard-head__title fs-25 black--text font-weight-medium">
      <DashboardBreadcrumb :items="breadCrumbItems" />
    </div>
    <div class="dashboard__body__exports mt-4" :class="{ 'mt-7': xsOrsm }">
      <div
        class="dashboard__body__exports__header mb-6 d-sm-flex justify-space-between align-center"
        :class="{ 'text-center': xsOrsm }"
      >
        <div class="dashboard__body__exports__header__content">
          <div class="dashboard__body__exports__header__content--title">
            Want to add a new Export Job?
          </div>
          <div class="dashboard__body__exports__header__content--subtitle">
            Click on the following button to add an export job
          </div>
        </div>
        <div class="dashboard__body__exports__header__button" :class="{ 'mt-4': xsOrsm }">
          <v-btn
            width="255"
            color="button-primary"
            large
            :loading="addNewExportJobButtonLoading"
            class="white--text"
            @click="addNewExportJobHandler"
          >
            <span class="font-weight-bold fs-15">Add New Export Job</span>
          </v-btn>
        </div>
      </div>
      <v-divider class="mb-6"></v-divider>
      <div class="dashboard__body__exports__search mb-6" :class="searchWidth">
        <DashboardSearch
          text-label="Search Export Data"
          description="Enter Job details that you want to search"
          @dashboard-search="dashboardSearchActionHandler"
        />
      </div>
      <v-row class="loader fill-height mt-8 py-6" align="center" justify="center" v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-row>

      <div class="dashboard__body__exports__list" v-else>
        <template v-if="exportJobData.length > 0">
          <div v-for="item in paginatedData" :key="item.id" class="mb-5">
            <ExportInfoCard
              :isEditActionLoading="isEditActionLoading"
              :isDeleteActionLoading="isDeleteActionLoading"
              :item="item"
              :bus="bus"
              @flatFile-Error="flatFileErrorHandler"
              @open-delete-confirmation-dialog="showDeleteConfirmationDialogHandler"
              @delete-export-job-from-array="deleteExportJobFromArray"
            />
          </div>
          <div v-if="exportJobData.length > 10" class="text-xs-center pt-2">
            <v-pagination
              rounded
              v-model="pagination.pageNumber"
              light
              @input="nextPage"
              :length="pages"
            ></v-pagination>
          </div>
        </template>
        <template v-else>
          <div class="dashboard__body__exports__list--no-data d-flex justify-center align-center font-weight-medium">
            No Export Job Added
          </div>
        </template>
        <ConfirmDeleteDialog
          v-if="showDeleteConfirmationDialog"
          @clicked-yes="approvedDeleteExportJob"
          :id="exportJobId"
          :name="exportJobName"
          @clicked-no="unapprovedDeleteExportJob"
        />
        <NoClientsModal v-if="showNoClientModal" @close-no-client-modal="showNoClientModal = false" />
        <FlatFileErrorModal
          :errors="flatFileErrors"
          v-if="showFlatFileErrorModal"
          @close-no-client-modal="showFlatFileErrorModal = false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DashboardBreadcrumb from "@/modules/DashboardModule/components/DashboardBreadcrumb";
import NoClientsModal from "@/modules/DashboardModule/components/NoClientsModal";
import FlatFileErrorModal from "@/modules/DashboardModule/components/FlatFileErrorModal";
import DashboardSearch from "@/modules/DashboardModule/components/DashboardSearch";
import ExportInfoCard from "@/modules/DashboardModule/components/ExportInfoCard";
import ConfirmDeleteDialog from "@/modules/DashboardModule/components/ConfirmDeleteDialog";
import { GET_EXPORT_JOBS } from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/actionTypes";
// import { SNACKBAR } from "@/store/actionTypes";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
import Vue from "vue";
export default {
  name: "Export",
  components: {
    DashboardBreadcrumb,
    FlatFileErrorModal,
    NoClientsModal,
    ConfirmDeleteDialog,
    DashboardSearch,
    ExportInfoCard
  },
  data() {
    return {
      exportJobData: [],
      originalExportJobsData: [],
      flatFileErrors: [],
      loading: false,
      showNoClientModal: false,
      showFlatFileErrorModal: false,
      addNewExportJobButtonLoading: false,
      isEditActionLoading: false,
      isDeleteActionLoading: false,
      showDeleteConfirmationDialog: false,
      exportJobId: null,
      pagination: {
        pageNumber: 1,
        jobsPerPage: 10
      },
      exportJobName: null,
      bus: new Vue()
    };
  },
  mounted() {
    this.getExportJobs(this.globalTimePeriodId);
  },
  mixins: [commonMethodsMixin],
  methods: {
    getExportJobs(timePeriodId) {
      this.loading = true;
      this.addNewExportJobButtonLoading = true;
      this.$store
        .dispatch(GET_EXPORT_JOBS, timePeriodId)
        .then(res => {
          if (res) {
            this.exportJobData = res;
            this.originalExportJobsData = res;
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.loading = false;
          this.addNewExportJobButtonLoading = false;
        });
    },
    nextPage(page) {
      this.pagination.pageNumber = page;
    },
    addNewExportJobHandler() {
      const exporters = this.$store.state.DashboardModuleStore.exporters;
      if (exporters.length <= 0) {
        this.showNoClientModal = true;
        return;
      }
      window.localStorage.removeItem("exportJob");
      window.localStorage.removeItem("sbMain");
      this.addNewExportJobButtonLoading = true;
      this.$store.commit(MT.SET_SBMAIN_BLANK);
      this.$store.commit(MT.SET_INVOICE_BLANK);
      this.$store.commit(MT.SET_ITEM_BLANK);
      this.$store.commit(MT.SET_ITEM_ACCESS_BLANK);
      this.$store.commit(MT.SET_DRAWBACK_BLANK);
      this.$store.commit(MT.SET_STATEMENT_BLANK);
      this.$store.commit(MT.SET_LICENSE_BLANK);
      this.$store.commit(MT.SET_PACKING_LIST_BLANK);
      this.$store.commit(MT.SET_SUPPORTING_DOC_BLANK);
      this.$store.commit(MT.SET_THIRD_PARTY_BLANK);
      this.$store.commit(MT.SET_EXPORT_JOB_BLANK);
      this.computeNewExportJobNumber();
      this.$router.push({
        name: "dashboard.export.sbMain",
        params: { exportJobId: "new" }
      });
      this.addNewExportJobButtonLoading = false;
      return;
    },
    computeNewExportJobNumber() {
      // places = length of jobName 00001, 00400
      const places = 5;
      let jobName = 0;
      if (this.exportJobData && this.exportJobData.length > 0) {
        // parsing int the job name
        jobName = this.exportJobData[0]["jobName"] !== undefined ? parseInt(this.exportJobData[0]["jobName"]) : 0;
      }
      // incrementing number
      jobName += 1;
      // assigning leading zeros to number
      var zero = places - jobName.toString().length + 1;
      jobName = Array(+(zero > 0 && zero)).join("0") + jobName;
      // storing the value in sb main job name
      this.$store.commit(MT.SET_SBMAIN_NAME, { value: jobName });
      return;
    },
    flatFileErrorHandler(err) {
      this.flatFileErrors = err.data.message;
      this.showFlatFileErrorModal = true;
    },
    dashboardSearchActionHandler(searchedString) {
      this.exportJobData = [...this.originalExportJobsData];
      if (searchedString === "") {
        return;
      }
      this.exportJobData = this.exportJobData.filter(exportJob => {
        return searchedString
          .toLowerCase()
          .split(" ")
          .every(
            v =>
              exportJob.jobName.toLowerCase().includes(v) ||
              exportJob.exporterName.toLowerCase().includes(v) ||
              exportJob.jobDate.toLowerCase().includes(v) ||
              exportJob.invoiceName.toLowerCase().includes(v) ||
              exportJob.schemeAbbreviations.toLowerCase().includes(v)
          );
      });
    },
    approvedDeleteExportJob(id) {
      this.showDeleteConfirmationDialog = false;
      this.bus.$emit("export-job-delete-confirmation", {
        exportJobId: id
      });
    },
    showDeleteConfirmationDialogHandler(data) {
      this.exportJobId = data.id;
      this.exportJobName = data.jobName;
      this.showDeleteConfirmationDialog = true;
    },
    unapprovedDeleteExportJob(id) {
      // if on confirmation dialog, user clicked NO
      this.showDeleteConfirmationDialog = false;
      this.bus.$emit("export-job-delete-denial", {
        exportJobId: id
      });
    },
    deleteExportJobFromArray(data) {
      this.exportJobData.splice(
        this.exportJobData.findIndex(exportJobData => exportJobData.id === data.id),
        1
      );
    }
  },
  watch: {
    globalTimePeriodId(newVal, oldVal) {
      if (newVal !== null) {
        oldVal;
        this.getExportJobs(newVal);
      }
    }
  },
  computed: {
    pages() {
      return this.pagination.jobsPerPage ? Math.ceil(this.exportJobData.length / this.pagination.jobsPerPage) : 0;
    },
    paginatedData() {
      const start = this.pagination.pageNumber * this.pagination.jobsPerPage - this.pagination.jobsPerPage,
        end = start + this.pagination.jobsPerPage;
      return this.exportJobData.slice(start, end);
    },
    breadCrumbItems() {
      return [
        {
          title: "Dashboard",
          route: "dashboard.home",
          children: [
            {
              title: "Export",
              route: "dashboard.export"
            }
          ]
        }
      ];
    }
  }
};
</script>
<style lang="scss">
.dashboard__body__exports {
  .v-divider {
    border-top-width: 2px;
  }
  &__header {
    &__content {
      &--title {
        font-size: 20px;
        font-weight: 500;
      }
      &--subtitle {
        font-size: 15px;
      }
    }
  }
  &__search {
    margin: auto;
  }
  &__list {
    &--no-data {
      height: 20vh;
      width: 100%;
      font-size: 16px;
      color: #666666;
    }
  }
}
.v-pagination__navigation {
  .v-icon {
    font-size: 15px;
  }
}
</style>
